import React from 'react';
import PropTypes from 'prop-types';
import s from './VerticalContainer.module.scss';

const VerticalContainer = ({ children }) => (
  <div className={s.root}>{children}</div>
);

VerticalContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default VerticalContainer;
